<template>
    <div class="content-wrapper-scroll">
        <div class="content-wrapper">
            <div class="row gutters">
                <div class="col-sm-12">
                    <div class="card fa-formula-card">
                        <div class="card-header d-flex justify-content-between align-items-center">
                            <h5 class="mb-0">Equation Builder</h5>
                            <div class="d-flex align-items-center gap-2">
                                <button
                                    v-if="!showCreateForm"
                                    type="button"
                                    class="btn btn-sm btn-primary"
                                    @click="openCreateForm"
                                >
                                    <i class="fas fa-plus me-1"></i> Add Formula Builder
                                </button>
                                <button
                                    v-else
                                    type="button"
                                    class="btn btn-sm btn-outline-secondary"
                                    @click="closeCreateForm"
                                >
                                    Back
                                </button>
                                <!-- <router-link to="/templates" class="btn btn-link btn-sm text-muted p-0" title="Back to templates" aria-label="Close">
                                    <i class="fas fa-times fa-lg"></i>
                                </router-link> -->
                            </div>
                        </div>
                        <div class="card-body">
                            <template v-if="!showCreateForm">
                                <div class="row mb-3">
                                    <div class="col-sm-12">
                                        <div class="input-group">
                                            <input class="form-control" type="text" placeholder="Type here and press enter to search" v-model="listMeta.search" @keyup.enter="index">
                                            <span class="input-group-text"><i class="fas fa-search"></i></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-responsive tabletop">
                                    <table class="table table-bordered table-striped">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th @click="sortList('equation_name')">
                                                    Equation Name
                                                    <span>
                                                        <i v-if="listMeta.field === 'equation_name' && listMeta.order_by === 'asc'" class="fas fa-sort-up"></i>
                                                        <i v-else-if="listMeta.field === 'equation_name' && listMeta.order_by === 'desc'" class="fas fa-sort-down"></i>
                                                        <i v-else class="fas fa-sort"></i>
                                                    </span>
                                                </th>
                                                <th @click="sortList('equation_date')">
                                                    Date
                                                    <span>
                                                        <i v-if="listMeta.field === 'equation_date' && listMeta.order_by === 'asc'" class="fas fa-sort-up"></i>
                                                        <i v-else-if="listMeta.field === 'equation_date' && listMeta.order_by === 'desc'" class="fas fa-sort-down"></i>
                                                        <i v-else class="fas fa-sort"></i>
                                                    </span>
                                                </th>
                                                <th>Calculated Value</th>
                                                <th class="text-center" style="width: 110px">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-if="equationRows.length === 0">
                                                <td colspan="5" class="text-center">No records found</td>
                                            </tr>
                                            <tr v-for="(row, key) in equationRows" :key="'faeq-' + row.fa_stat_id">
                                                <td>{{ listMeta.from + key }}</td>
                                                <td>{{ row.equation_name }}</td>
                                                <td>{{ row.equation_date }}</td>
                                                <td>{{ row.calculated_value != null && row.calculated_value !== '' ? row.calculated_value : '-' }}</td>
                                                <td class="td-actions text-center">
                                                    <a
                                                        href="#"
                                                        class="icon green me-2"
                                                        title="View formula"
                                                        @click.prevent="viewEquation(row)"
                                                    >
                                                        <i class="icon-eye"></i>
                                                    </a>
                                                    <a
                                                        href="#"
                                                        class="icon red"
                                                        title="Delete"
                                                        @click.prevent="deleteEquation(row)"
                                                    >
                                                        <i class="icon-cancel"></i>
                                                    </a>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="form-actions-footer">
                                    <div class="text-end row">
                                        <div class="col-sm-2">
                                            <select class="form-control" v-model="listMeta.per_page" @change="onPerPageChange">
                                                <option>10</option>
                                                <option>15</option>
                                                <option>20</option>
                                                <option>25</option>
                                                <option>30</option>
                                            </select>
                                        </div>
                                        <div class="col-sm-10">
                                            <Pagination class="pagination pagination-sm" :maxPage="listMeta.maxPage" :totalPages="listMeta.lastPage" :currentPage="listMeta.currentPage" @pagechanged="onPageChange" />
                                        </div>
                                    </div>
                                </div>
                            </template>

                            <template v-else>
                            <p v-if="loadError" class="text-danger">{{ loadError }}</p>
                            <div v-if="loading" class="text-center py-4">
                                <span class="text-muted">Loading templates…</span>
                            </div>

                            <template v-else>
                                <div class="row gutters mb-3">
                                    <div class="col-md-12">
                                        <div class="field-wrapper">
                                            <label class="field-placeholder">Equation name</label>
                                            <input
                                                v-model="equationName"
                                                type="text"
                                                class="form-control"
                                                :class="{'is-invalid': errors.equation_name}"
                                                placeholder="Enter a name for this equation"
                                                maxlength="255"
                                                autocomplete="off"
                                            />
                                            <span v-if="errors.equation_name" class="invalid-feedback">{{ errors.equation_name[0] }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="row gutters mb-3">
                                    <div class="col-md-12">
                                        <div class="field-wrapper">
                                            <label class="field-placeholder">Equipment Component</label>
                                            <div class="fa-comp-dropdown">
                                                <button
                                                    type="button"
                                                    class="btn btn-outline-secondary btn-sm w-100 d-flex justify-content-between align-items-center"
                                                    @click="toggleDropdown"
                                                >
                                                    <span class="text-truncate">
                                                        {{ selectedCompositionLabel }}
                                                    </span>
                                                    <i class="fas" :class="dropdownOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                                                </button>

                                                <div v-if="dropdownOpen" class="fa-comp-panel" @click.stop>
                                                    <div class="input-group input-group-sm mb-2">
                                                        <span class="input-group-text"><i class="fas fa-search"></i></span>
                                                        <input
                                                            v-model="searchTerm"
                                                            type="text"
                                                            class="form-control"
                                                            placeholder="Search equipment / check type / template…"
                                                            @keydown.esc.prevent="closeDropdown"
                                                        >
                                                        <button
                                                            v-if="searchTerm"
                                                            class="btn btn-outline-secondary"
                                                            type="button"
                                                            @click="searchTerm = ''"
                                                        >
                                                            Clear
                                                        </button>
                                                    </div>

                                                    <div class="fa-composition-list" role="listbox" aria-multiselectable="false">
                                                        <button
                                                            v-for="opt in filteredCatalog"
                                                            :key="opt.tecId"
                                                            type="button"
                                                            class="fa-comp-row fa-comp-row-single"
                                                            :class="{ 'is-selected': isTecSelected(opt.tecId) }"
                                                            :disabled="isTecSelected(opt.tecId)"
                                                            @click="selectTec(opt)"
                                                        >
                                                            <span class="fa-comp-label">{{ opt.label }}</span>
                                                        </button>
                                                        <div v-if="!filteredCatalog.length" class="p-2 small text-muted">
                                                            No matches.
                                                        </div>
                                                    </div>

                                                    <div class="d-flex justify-content-between align-items-center mt-2">
                                                        <button type="button" class="btn btn-light btn-sm" @click="clearComposition" :disabled="!selectedTecId">
                                                            Clear
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <small class="text-muted d-block mt-1">
                                                Click one line to select. Missing values are shown as "-" and saved for future recalculation.
                                            </small>
                                            <div v-if="selectedComposition" class="mt-2">
                                                <div class="fa-selected-composition">
                                                    <div class="small text-muted">Selected composition</div>
                                                    <div class="fw-semibold">{{ selectedComposition.label }}</div>
                                                </div>
                                            </div>
                                            <div v-if="selectedTecId" class="mt-2 small">
                                                <span v-if="loadingValueTecId === String(selectedTecId)" class="text-muted">
                                                    Loading value...
                                                </span>
                                                <span v-else-if="selectedFetchedValue !== null" :class="selectedFetchedValue === '-' ? 'text-muted' : 'text-success'">
                                                    Value: {{ selectedFetchedValue }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row gutters align-items-end mb-3">
                                    <div class="col-md-4">
                                        <div class="field-wrapper">
                                            <label class="field-placeholder">Operator</label>
                                            <select v-model="selectedOperator" class="form-control">
                                                <option value="">Select operator</option>
                                                <option v-for="op in operators" :key="op" :value="op">{{ op }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="field-wrapper">
                                            <label class="field-placeholder">Value</label>
                                            <input
                                                v-model="operatorValue"
                                                type="text"
                                                class="form-control"
                                                :placeholder="operatorValuePlaceholder"
                                                autocomplete="off"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <p class="small text-muted mb-3">
                                    For <strong>pow</strong> enter arguments like <code>2, 3</code> → <code>pow ( 2 , 3 )</code>.
                                    For <strong>exp</strong> enter a value like <code>2</code> → <code>exp ( 2 )</code>.
                                    For operators like <strong>*</strong> with value <strong>2</strong> → <code>* 2</code>.
                                </p>

                                <div class="d-flex flex-wrap gap-2 mb-4">
                                    <button type="button" class="btn fa-formula-btn-add" @click="addToFormula">
                                        <i class="fas fa-plus me-1"></i> Add
                                    </button>
                                    <button type="button" class="btn fa-formula-btn-undo" :disabled="!segments.length" @click="undoLast">
                                        <i class="fas fa-undo me-1"></i> Undo
                                    </button>
                                    <button type="button" class="btn fa-formula-btn-clear" @click="clearFormula">
                                        <i class="fas fa-sync-alt me-1"></i> Clear
                                    </button>
                                </div>

                                <div class="field-wrapper mb-2">
                                    <label class="field-placeholder">Formula</label>
                                    <textarea
                                        :value="displayFormula"
                                        class="form-control fa-formula-textarea"
                                        rows="6"
                                        placeholder="Use Add to build your formula"
                                        readonly
                                    />
                                </div>
                                <p v-if="evaluationMessage" class="small text-muted mb-0">{{ evaluationMessage }}</p>
                            </template>
                            </template>
                        </div>
                        <div v-if="showCreateForm" class="card-footer bg-white d-flex flex-wrap justify-content-between align-items-center gap-2">
                            <div class="d-flex flex-wrap gap-2">
                                <button type="button" class="btn btn-primary" :disabled="!formula.trim()" @click="evaluateFormula">
                                    <i class="fas fa-eye me-1"></i> Evaluate
                                </button>
                                <button type="button" class="btn btn-info text-white" @click="saveFormula">
                                    <i class="fas fa-save me-1"></i> Update
                                </button>
                            </div>
                            <router-link to="/templates" class="btn btn-secondary">Close</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="faEquationViewModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">View Formula</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="closeViewModal"></button>
                    </div>
                    <div class="modal-body">
                        <div v-if="viewLoading" class="text-center py-4 text-muted">
                            Loading formula...
                        </div>
                        <template v-else-if="viewDetail">
                            <div class="row mb-3">
                                <div class="col-md-6">
                                    <div class="small text-muted">Equation Name</div>
                                    <div class="fw-semibold">{{ viewDetail.equation_name }}</div>
                                </div>
                                <div class="col-md-3">
                                    <div class="small text-muted">Date</div>
                                    <div>{{ viewDetail.equation_date || '-' }}</div>
                                </div>
                                <div class="col-md-3">
                                    <div class="small text-muted">Calculated Value</div>
                                    <div>{{ viewDetail.calculated_value != null && viewDetail.calculated_value !== '' ? viewDetail.calculated_value : '-' }}</div>
                                </div>
                            </div>

                            <div class="mb-3">
                                <label class="form-label small text-muted mb-1">Formula with check types</label>
                                <textarea
                                    class="form-control fa-formula-textarea"
                                    rows="4"
                                    readonly
                                    :value="viewDetail.formula_with_check_types || viewDetail.formula || ''"
                                />
                            </div>

                            <div class="table-responsive">
                                <table class="table table-bordered table-sm mb-0">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Check Type</th>
                                            <th>Equipment</th>
                                            <th>Template</th>
                                            <th>Value</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="!viewDetail.components || !viewDetail.components.length">
                                            <td colspan="5" class="text-center text-muted">No components found</td>
                                        </tr>
                                        <tr
                                            v-for="(component, index) in viewDetail.components"
                                            :key="'fa-view-comp-' + component.fa_equation_id"
                                        >
                                            <td>{{ component.formula_no || index + 1 }}</td>
                                            <td>{{ component.check_type_name || '-' }}</td>
                                            <td>{{ component.equipment_name || component.equipment_uid || '-' }}</td>
                                            <td>{{ component.template_name || '-' }}</td>
                                            <td>{{ component.value != null && component.value !== '' ? component.value : '-' }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="closeViewModal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue';

export default {
    name: 'FaFormulaBuilder',
    components: { Pagination },
    data() {
        return {
            loading: true,
            loadError: '',
            compositionCatalog: [],
            showCreateForm: false,
            equationRows: [],
            listMeta: {
                search: '',
                order_by: 'desc',
                field: 'equation_date',
                per_page: 10,
                currentPage: 1,
                lastPage: 1,
                from: 1,
                maxPage: 1,
            },
            selectedTecId: '',
            equationName: '',
            errors: [],
            fetchedValuesByTecId: {},
            fetchedMissingValueByTecId: {},
            fetchedUecIdByTecId: {},
            fetchedUtIdByTecId: {},
            fetchedEquipmentTypeIdByTecId: {},
            loadingValueTecId: '',
            dropdownOpen: false,
            searchTerm: '',
            selectedOperator: '',
            operatorValue: '',
            formula: '',
            segments: [],
            evaluationMessage: '',
            operators: ['+', '-', '*', '/', '(', ')', 'exp', 'pow'],
            storageKey: 'fa_formula_builder_draft',
            viewLoading: false,
            viewDetail: null,
            viewModalInstance: null,
        };
    },
    created() {
        try {
            localStorage.removeItem(this.storageKey);
        } catch (_e) {
            // ignore local storage errors
        }
        this.index();
    },
    mounted() {
        document.addEventListener('click', this.onOutsideClick, true);
    },
    beforeUnmount() {
        document.removeEventListener('click', this.onOutsideClick, true);
    },
    methods: {
        index() {
            const vm = this;
            const user = vm.$store.getters.user;
            const plantId = user && user.plant_id;
            let uri = 'paginateFAEquations?page=' + vm.listMeta.currentPage
                + '&search=' + encodeURIComponent(vm.listMeta.search || '')
                + '&order_by=' + vm.listMeta.order_by
                + '&field=' + vm.listMeta.field
                + '&per_page=' + vm.listMeta.per_page;
            if (plantId) {
                uri += '&plant_id=' + plantId;
            }
            vm.$store.dispatch('post', { uri })
                .then(function (response) {
                    const body = response.data || {};
                    vm.equationRows = Array.isArray(body.data) ? body.data : [];
                    const meta = body.meta || body;
                    vm.listMeta.lastPage = Number(meta.last_page || 1) || 1;
                    vm.listMeta.from = Number(meta.from || 1) || 1;
                    vm.listMeta.currentPage = Number(meta.current_page || vm.listMeta.currentPage) || 1;
                    vm.listMeta.maxPage = vm.listMeta.lastPage >= 3 ? 3 : vm.listMeta.lastPage;
                })
                .catch(function (error) {
                    vm.equationRows = [];
                    const message = (error.response && error.response.data && error.response.data.message) || 'Could not load equations.';
                    vm.$store.dispatch('error', message);
                });
        },
        sortList(field) {
            if (this.listMeta.field === field) {
                this.listMeta.order_by = this.listMeta.order_by === 'asc' ? 'desc' : 'asc';
            } else {
                this.listMeta.field = field;
                this.listMeta.order_by = 'asc';
            }
            this.listMeta.currentPage = 1;
            this.index();
        },
        onPageChange(page) {
            this.listMeta.currentPage = page;
            this.index();
        },
        onPerPageChange() {
            this.listMeta.currentPage = 1;
            this.index();
        },
        openCreateForm() {
            this.showCreateForm = true;
            this.resetCreateData();
            this.fetchTemplatesCatalog();
        },
        closeCreateForm() {
            this.showCreateForm = false;
            this.resetCreateData();
            this.index();
        },
        resetCreateData() {
            this.equationName = '';
            this.formula = '';
            this.segments = [];
            this.evaluationMessage = '';
            this.selectedTecId = '';
            this.selectedOperator = '';
            this.operatorValue = '';
            this.searchTerm = '';
            this.errors = [];
            this.fetchedValuesByTecId = {};
            this.fetchedMissingValueByTecId = {};
            this.fetchedUecIdByTecId = {};
            this.fetchedUtIdByTecId = {};
            this.fetchedEquipmentTypeIdByTecId = {};
            this.dropdownOpen = false;
            this.loading = false;
            this.loadError = '';
        },
        buildCompositionCatalog(templates) {
            const list = [];
            (templates || []).forEach((t) => {
                (t.equipments || []).forEach((eq) => {
                    (eq.is_fa_calc_components || []).forEach((comp) => {
                        const ct = (comp.check_type && comp.check_type.check_type_name) || 'Check';
                        const uid = String(eq.equipment_uid || '').trim();
                        const name = eq.equipment_name || '';
                        const equipTypeName =
                            (comp.equipment_type && comp.equipment_type.equipment_type_name) || '';
                        const compTypeName =
                            (comp.component_type && comp.component_type.component_type_name) || '';
                        const tecId = comp.template_equipment_component_id;
                        const combinedId = `${eq.equipment_id}${comp.check_type_id}`;
                        const middle = [name, equipTypeName, compTypeName, ct].filter(Boolean).join(' — ');
                        const label = `#${tecId} :: ${middle} (${t.template_name})`;
                        list.push({
                            tecId,
                            equipmentUid: uid,
                            equipmentId: eq.equipment_id,
                            checkTypeId: comp.check_type_id,
                            equipmentTypeId: comp.equipment_type_id,
                            templateId: t.template_id,
                            combinedId,
                            label,
                        });
                    });
                });
            });
            return list.sort((a, b) => String(a.label).localeCompare(String(b.label)));
        },

        isTecSelected(tecId) {
            return String(this.selectedTecId) === String(tecId);
        },

        async selectTec(option) {
            const id = String(option.tecId);
            this.selectedTecId = id;
            await this.fetchFACalcValue(option);
            this.closeDropdown();
        },

        clearComposition() {
            this.selectedTecId = '';
        },

        toggleDropdown() {
            this.dropdownOpen = !this.dropdownOpen;
        },

        closeDropdown() {
            this.dropdownOpen = false;
        },

        onOutsideClick(e) {
            if (!this.dropdownOpen) {
                return;
            }
            const root = this.$el && this.$el.querySelector ? this.$el.querySelector('.fa-comp-dropdown') : null;
            if (root && !root.contains(e.target)) {
                this.closeDropdown();
            }
        },

        faCalcTemplatesQuery(plantId) {
            const qs = new URLSearchParams();
            qs.set('plant_id', String(plantId));
            return `getTemplatesWithFaCalcEquipment?${qs.toString()}`;
        },

        parseComponentValue(rawValue) {
            if (rawValue === null || rawValue === undefined) {
                return { display: '-', numeric: null, missing: true };
            }
            const trimmed = String(rawValue).trim();
            if (trimmed === '' || trimmed === '-') {
                return { display: '-', numeric: null, missing: true };
            }
            const numericValue = Number(trimmed);
            if (Number.isFinite(numericValue)) {
                return { display: numericValue, numeric: numericValue, missing: false };
            }
            return { display: '-', numeric: null, missing: true };
        },

        async fetchFACalcValue(option) {
            const tecId = parseInt(option?.tecId, 10);
            const equipmentId = parseInt(option?.equipmentId, 10);
            const checkTypeId = parseInt(option?.checkTypeId, 10);
            if (
                !Number.isFinite(tecId) || tecId <= 0 ||
                !Number.isFinite(equipmentId) || equipmentId <= 0 ||
                !Number.isFinite(checkTypeId) || checkTypeId <= 0
            ) {
                return;
            }

            const cached = Object.prototype.hasOwnProperty.call(this.fetchedValuesByTecId, String(tecId));
            if (cached) {
                return;
            }

            this.loadingValueTecId = String(tecId);
            try {
                const latestUecResponse = await this.$store.dispatch('post', {
                    uri: 'getLatestUserEquipmentComponent',
                    data: {
                        equipment_id: equipmentId,
                        check_type_id: checkTypeId,
                        equipment_type_id: option.equipmentTypeId,
                    },
                });

                const latestUec = latestUecResponse?.data?.data;
                const parsed = this.parseComponentValue(latestUec ? latestUec.value : null);
                let uecId = null;
                let utId = null;

                if (latestUec) {
                    uecId = latestUec.user_equipment_component_id ? parseInt(latestUec.user_equipment_component_id, 10) : null;
                    utId = latestUec.user_template_id ? parseInt(latestUec.user_template_id, 10) : null;
                    const equipmentTypeId = latestUec.equipment_type_id ? parseInt(latestUec.equipment_type_id, 10) : null;
                    this.fetchedEquipmentTypeIdByTecId[String(tecId)] = Number.isFinite(equipmentTypeId) ? equipmentTypeId : null;
                }

                this.fetchedValuesByTecId[String(tecId)] = parsed.numeric;
                this.fetchedMissingValueByTecId[String(tecId)] = !latestUec || parsed.missing;
                this.fetchedUecIdByTecId[String(tecId)] = Number.isFinite(uecId) ? uecId : null;
                this.fetchedUtIdByTecId[String(tecId)] = Number.isFinite(utId) ? utId : null;
            } catch (error) {
                this.fetchedValuesByTecId[String(tecId)] = null;
                this.fetchedMissingValueByTecId[String(tecId)] = true;
                this.fetchedUecIdByTecId[String(tecId)] = null;
                this.fetchedUtIdByTecId[String(tecId)] = null;
                const message =
                    (error.response && error.response.data && error.response.data.message) ||
                    'Could not load latest UserEquipmentComponent data.';
                this.$store.dispatch('error', message);
            } finally {
                this.loadingValueTecId = '';
            }
        },

        fetchTemplatesCatalog() {
            const vm = this;
            const plantId = vm.$store.getters.user && vm.$store.getters.user.plant_id;
            if (!plantId) {
                vm.loading = false;
                vm.loadError = 'Plant is not set for your user.';
                return;
            }
            vm.loading = true;
            vm.loadError = '';
            vm.$store
                .dispatch('get', {
                    uri: vm.faCalcTemplatesQuery(plantId),
                })
                .then(function (response) {
                    const data = response.data.data || [];
                    vm.compositionCatalog = vm.buildCompositionCatalog(data);
                    vm.loading = false;
                })
                .catch(function (error) {
                    vm.loading = false;
                    vm.loadError =
                        (error.response && error.response.data && error.response.data.message) ||
                        'Could not load FA templates.';
                    vm.$store.dispatch('error', vm.loadError);
                });
        },

        getNumericForTecId(tecId) {
            const key = String(tecId);
            if (this.fetchedMissingValueByTecId[key]) {
                return null;
            }
            const fetched = this.fetchedValuesByTecId[key];
            return Number.isFinite(fetched) ? fetched : null;
        },

        hasMissingValuesInFormula() {
            return this.extractTecIdsFromFormula().some((id) => {
                const key = String(id);
                if (this.fetchedMissingValueByTecId[key]) {
                    return true;
                }
                return !Object.prototype.hasOwnProperty.call(this.fetchedValuesByTecId, key);
            });
        },

        getDisplayValueForTecId(tecId) {
            const key = String(tecId);
            if (!Object.prototype.hasOwnProperty.call(this.fetchedValuesByTecId, key)) {
                return null;
            }
            if (this.fetchedMissingValueByTecId[key]) {
                return '-';
            }
            return this.fetchedValuesByTecId[key];
        },

        extractTecIdsFromFormula() {
            const ids = [];
            const seen = new Set();
            const re = /\{tec:(\d+)\}/g;
            const src = String(this.formula || '');
            let match = re.exec(src);
            while (match !== null) {
                const id = String(match[1]);
                if (!seen.has(id)) {
                    seen.add(id);
                    ids.push(id);
                }
                match = re.exec(src);
            }
            return ids;
        },

        formatFunctionArgs(value, argCount) {
            let v = String(value || '').trim();
            if (v.startsWith('(') && v.endsWith(')')) {
                v = v.slice(1, -1).trim();
            }
            const args = v.split(',').map((s) => s.trim()).filter((s) => s !== '');
            if (argCount === 1) {
                return args[0] || v;
            }
            if (args.length >= 2) {
                return `${args[0]} , ${args[1]}`;
            }
            return v.replace(/\s*,\s*/g, ' , ');
        },

        buildOperatorChunk(op, val) {
            const o = String(op || '').trim();
            const v = String(val || '').trim();
            if (!o && !v) {
                return null;
            }
            if (o === 'pow') {
                if (!v) {
                    this.$store.dispatch('error', 'Enter arguments for pow, e.g. 2, 3');
                    return null;
                }
                return `pow ( ${this.formatFunctionArgs(v, 2)} )`;
            }
            if (o === 'exp') {
                if (!v) {
                    this.$store.dispatch('error', 'Enter a value for exp.');
                    return null;
                }
                return `exp ( ${this.formatFunctionArgs(v, 1)} )`;
            }
            if (o) {
                const parts = [o];
                if (v) {
                    parts.push(v);
                }
                return parts.join(' ');
            }
            if (v === '-') {
                return null;
            }
            return v;
        },

        substituteFormulaTokens(expr) {
            let e = String(expr || '');
            e = e.replace(/\{tec:(\d+)\}/g, (_m, id) => String(this.getNumericForTecId(id)));
            e = e.replace(/\{(\d+)\}/g, (_m, id) => String(this.getNumericForTecId(id)));
            return e;
        },

        prepareExpressionForEval(expr) {
            if (this.hasMissingValuesInFormula()) {
                return { ok: true, isDash: true, result: '-' };
            }

            let e = this.substituteFormulaTokens(expr).trim();
            if (!e) {
                return { ok: false, error: 'Formula is empty.', expr: '' };
            }
            e = e.replace(/\bpow\s*\(\s*([^,)]+)\s*,\s*([^)]+)\s*\)/gi, 'Math.pow($1,$2)');
            e = e.replace(/\bexp\s*\(\s*([^)]+)\s*\)/gi, 'Math.exp($1)');
            return { ok: true, expr: e };
        },

        evaluatePreparedExpression(expr) {
            try {
                const fn = new Function('Math', `"use strict"; return (${expr});`);
                const result = fn(Math);
                if (typeof result === 'number' && Number.isFinite(result)) {
                    return { ok: true, result };
                }
                return { ok: false, error: 'Expression did not evaluate to a finite number.' };
            } catch (_e) {
                return { ok: false, error: 'Could not evaluate the formula.' };
            }
        },

        computeEvaluatedResult() {
            const prepared = this.prepareExpressionForEval(this.formula);
            if (!prepared.ok) {
                return prepared;
            }
            if (prepared.isDash) {
                return { ok: true, result: '-', isDash: true };
            }
            return this.evaluatePreparedExpression(prepared.expr);
        },

        addToFormula() {
            const parts = [];
            const tecNum = parseInt(this.selectedTecId, 10);
            if (Number.isFinite(tecNum) && tecNum > 0) {
                parts.push(`{tec:${tecNum}}`);
            }
            const operatorChunk = this.buildOperatorChunk(this.selectedOperator, this.operatorValue);
            if (operatorChunk === null && (this.selectedOperator === 'pow' || this.selectedOperator === 'exp')) {
                return;
            }
            if (operatorChunk) {
                parts.push(operatorChunk);
            }
            if (!parts.length) {
                return;
            }
            const chunk = parts.join(' ');
            this.segments.push(chunk);
            this.formula = this.segments.join(' ');
            this.evaluationMessage = '';
            this.selectedTecId = '';
            this.selectedOperator = '';
            this.operatorValue = '';
        },

        undoLast() {
            this.segments.pop();
            this.formula = this.segments.join(' ');
            this.evaluationMessage = '';
        },

        clearFormula() {
            this.segments = [];
            this.formula = '';
            this.equationName = '';
            this.evaluationMessage = '';
            this.selectedTecId = '';
            this.selectedOperator = '';
            this.operatorValue = '';
        },

        evaluateFormula() {
            const vm = this;
            vm.evaluationMessage = '';
            if (!vm.formula.trim()) {
                return;
            }
            const prepared = vm.prepareExpressionForEval(vm.formula);
            if (!prepared.ok) {
                vm.$store.dispatch('error', prepared.error);
                return;
            }
            if (prepared.isDash) {
                vm.evaluationMessage = 'Result: -';
                vm.$store.dispatch('success', 'Evaluated: -');
                return;
            }
            const evaluated = vm.evaluatePreparedExpression(prepared.expr);
            if (!evaluated.ok) {
                vm.$store.dispatch('error', evaluated.error);
                return;
            }
            vm.evaluationMessage = `Result: ${evaluated.result}`;
            vm.$store.dispatch('success', `Evaluated: ${evaluated.result}`);
        },

        formulaForStorage() {
            return String(this.formula || '').replace(/\{tec:(\d+)\}/g, '{$1}');
        },

        async saveFormula() {
            // Clear previous errors
            this.errors = [];
            
            // Validate equation name
            if (!this.equationName || !String(this.equationName).trim()) {
                this.errors = { ...this.errors, equation_name: ['Equation name is required.'] };
                this.$store.dispatch('error', 'Equation name is required.');
                return;
            }
            
            const tecIds = this.extractTecIdsFromFormula();
            if (!tecIds.length) {
                this.$store.dispatch('error', 'Add at least one composition in formula.');
                return;
            }
            
            // Validate components have required fields
            const missingFields = [];
            for (const tecId of tecIds) {
                const selected = (this.compositionCatalog || []).find((c) => String(c.tecId) === String(tecId)) || null;
                if (!selected) {
                    missingFields.push(`Composition tec:${tecId} not found`);
                    continue;
                }
                
                if (!selected.equipmentTypeId) {
                    missingFields.push(`Equipment type ID is required for component: ${selected.label}`);
                }
            }
            
            if (missingFields.length > 0) {
                this.$store.dispatch('error', 'Validation failed. Please check the required fields.');
                return;
            }

            const components = [];
            for (const tecId of tecIds) {
                const selected = (this.compositionCatalog || []).find((c) => String(c.tecId) === String(tecId)) || null;
                if (!selected) {
                    this.$store.dispatch('error', `Composition not found for token tec:${tecId}.`);
                    return;
                }
                await this.fetchFACalcValue(selected);
                const tecKey = String(selected.tecId);
                const uecId = this.fetchedUecIdByTecId[tecKey];
                const utId = this.fetchedUtIdByTecId[tecKey];
                const templateId = selected.templateId;
                const isMissing = this.fetchedMissingValueByTecId[tecKey]
                    || !Number.isFinite(uecId)
                    || !Number.isFinite(utId);
                const value = isMissing
                    ? '-'
                    : String(this.fetchedValuesByTecId[tecKey]);
                components.push({
                    formula_no: String(selected.tecId),
                    user_template_id: Number.isFinite(utId) ? utId : null,
                    template_id: templateId,
                    user_equipment_component_id: Number.isFinite(uecId) ? uecId : null,
                    equipment_id: selected.equipmentId,
                    check_type_id: selected.checkTypeId,
                    equipment_type_id: selected.equipmentTypeId,
                    value,
                });
            }

            const evaluated = this.computeEvaluatedResult();
            if (!evaluated.ok) {
                this.$store.dispatch('error', evaluated.error);
                return;
            }

            try {
                await this.$store.dispatch('post', {
                    uri: 'saveFAEquation',
                    data: {
                        equation_name: String(this.equationName).trim(),
                        plant_id: this.$store.getters.user && this.$store.getters.user.plant_id,
                        formula: this.formulaForStorage(),
                        components,
                        calculated_value: String(evaluated.result),
                    },
                });
                try {
                    localStorage.removeItem(this.storageKey);
                } catch (_e) {
                    // ignore local storage errors
                }
                this.errors = [];
                this.$store.dispatch('success', 'Saved.');
                this.closeCreateForm();
            } catch (error) {
                this.errors = (error.response && error.response.data && error.response.data.errors) || [];
                const message =
                    (error.response && error.response.data && error.response.data.message) ||
                    'Could not save.';
                this.$store.dispatch('error', message);
            }
        },

        showViewModal() {
            const modalEl = document.getElementById('faEquationViewModal');
            if (!modalEl) {
                return;
            }
            const bootstrap = window.bootstrap || window.Bootstrap;
            if (bootstrap && bootstrap.Modal) {
                if (bootstrap.Modal.getInstance) {
                    this.viewModalInstance = bootstrap.Modal.getInstance(modalEl);
                }
                if (!this.viewModalInstance) {
                    this.viewModalInstance = new bootstrap.Modal(modalEl);
                }
                this.viewModalInstance.show();
                return;
            }
            modalEl.classList.add('show');
            modalEl.style.display = 'block';
            document.body.classList.add('modal-open');
        },

        closeViewModal() {
            const modalEl = document.getElementById('faEquationViewModal');
            if (!modalEl) {
                return;
            }
            const bootstrap = window.bootstrap || window.Bootstrap;
            if (bootstrap && bootstrap.Modal) {
                const instance = this.viewModalInstance
                    || (bootstrap.Modal.getInstance ? bootstrap.Modal.getInstance(modalEl) : null);
                if (instance) {
                    instance.hide();
                }
                return;
            }
            modalEl.classList.remove('show');
            modalEl.style.display = 'none';
            document.body.classList.remove('modal-open');
        },

        async viewEquation(row) {
            this.viewLoading = true;
            this.viewDetail = null;
            this.showViewModal();
            try {
                const response = await this.$store.dispatch('post', {
                    uri: 'getFAEquation',
                    data: {
                        fa_stat_id: row.fa_stat_id,
                    },
                });
                this.viewDetail = (response.data && response.data.data) ? response.data.data : (response.data || null);
            } catch (error) {
                this.closeViewModal();
                const message =
                    (error.response && error.response.data && error.response.data.message) ||
                    'Could not load equation details.';
                this.$store.dispatch('error', message);
            } finally {
                this.viewLoading = false;
            }
        },

        async deleteEquation(row) {
            if (!confirm(`Are you sure you want to delete the equation "${row.equation_name}"?`)) {
                return;
            }

            try {
                await this.$store.dispatch('post', {
                    uri: 'deleteFAEquation',
                    data: {
                        fa_stat_id: row.fa_stat_id,
                    },
                });
                this.$store.dispatch('success', 'Equation deleted successfully.');
                await this.index(); // Refresh the table
            } catch (error) {
                const message =
                    (error.response && error.response.data && error.response.data.message) ||
                    'Could not delete equation.';
                this.$store.dispatch('error', message);
            }
        },

        restoreLocal() {},
    },
    computed: {
        filteredCatalog() {
            const q = String(this.searchTerm || '').trim().toLowerCase();
            const base = this.compositionCatalog || [];
            if (!q) {
                return base;
            }
            return base.filter((o) => String(o.label).toLowerCase().includes(q));
        },
        selectedCompositionLabel() {
            if (!this.selectedTecId) {
                return 'Select one composition';
            }
            const row = (this.compositionCatalog || []).find((c) => String(c.tecId) === String(this.selectedTecId));
            return row ? row.label : 'Select one composition';
        },
        selectedComposition() {
            if (!this.selectedTecId) {
                return null;
            }
            return (this.compositionCatalog || []).find((c) => String(c.tecId) === String(this.selectedTecId)) || null;
        },
        selectedFetchedValue() {
            if (!this.selectedTecId) {
                return null;
            }
            return this.getDisplayValueForTecId(this.selectedTecId);
        },
        displayFormula() {
            const src = String(this.formula || '');
            if (!src) {
                return '';
            }
            return src.replace(/\{tec:(\d+)\}/g, (_m, id) => {
                const row = (this.compositionCatalog || []).find((c) => String(c.tecId) === String(id));
                if (!row) {
                    return `{tec:${id}}`;
                }
                return `[#${row.tecId}]`;
            });
        },
        operatorValuePlaceholder() {
            const op = this.selectedOperator;
            if (op === 'pow') {
                return 'e.g. 2, 3 or (2, 3)';
            }
            if (op === 'exp') {
                return 'e.g. 2';
            }
            if (op === '*' || op === '/' || op === '+' || op === '-') {
                return 'e.g. 2';
            }
            return 'Value';
        },
    },
};
</script>

<style scoped>
.fa-formula-card {
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
}
.fa-composition-list {
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    max-height: 320px;
    overflow: auto;
    background: #fff;
}
.fa-comp-dropdown {
    position: relative;
}
.fa-comp-panel {
    position: absolute;
    z-index: 20;
    width: 100%;
    margin-top: 0.35rem;
    padding: 0.75rem;
    border: 1px solid #ced4da;
    border-radius: 0.5rem;
    background: #fff;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
}
.fa-comp-row {
    width: 100%;
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
    padding: 0.5rem 0.75rem;
    border: 0;
    background: transparent;
    text-align: left;
}
.fa-comp-row:hover {
    background: #f8f9fa;
}
.fa-comp-row.is-selected {
    background: #e7f1ff;
}
.fa-comp-row:disabled {
    opacity: 0.75;
    cursor: not-allowed;
}
.fa-comp-row-single {
    padding-left: 0.75rem;
}
.fa-comp-label {
    flex: 1;
    line-height: 1.25rem;
}
.fa-selected-composition {
    padding: 0.75rem;
    border: 1px solid #dbe7ff;
    border-radius: 0.5rem;
    background: #f5f9ff;
}
.fa-formula-textarea {
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
    font-size: 0.95rem;
    background-color: #f8f9fa;
}
.fa-formula-btn-add {
    background-color: #17a2b8;
    border-color: #17a2b8;
    color: #fff;
}
.fa-formula-btn-add:hover {
    background-color: #138496;
    border-color: #117a8b;
    color: #fff;
}
.fa-formula-btn-undo {
    background-color: #fd7e14;
    border-color: #fd7e14;
    color: #fff;
}
.fa-formula-btn-undo:hover:not(:disabled) {
    background-color: #e8590c;
    border-color: #dc6502;
    color: #fff;
}
.fa-formula-btn-clear {
    background-color: #ffc107;
    border-color: #ffc107;
    color: #212529;
}
.fa-formula-btn-clear:hover {
    background-color: #e0a800;
    border-color: #d39e00;
    color: #212529;
}
.gap-2 {
    gap: 0.5rem;
}
.tabletop .td-actions {
    white-space: nowrap;
    width: 90px;
    vertical-align: middle;
}
</style>
